// extracted by mini-css-extract-plugin
export default {"ellipsis":"yd8RtrppGJ7qR3c7ee9O","wrapper":"d8Mm_PJnWfsbzYz4zLbY","content":"RkP6hjSvFLEba0buIBfw","spin":"zfp9Y9xAvMNXmC7mYGts"};